export default __webpack_public_path__ + "static/10-a765987445cf6026999dd534c4a3e08d.png";